(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-contabilidad-anuales', {
                parent: 'entity',
                url: '/consortium-contabilidad-anuales?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadAnual'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales.html',
                    controller: 'ConsortiumContabilidadAnualController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-contabilidad-anuales.new', {
                parent: 'consortium-contabilidad-anuales',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales-new.html',
                    controller: 'ConsortiumContabilidadAnualNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-contabilidad-anuales'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-contabilidad-anuales',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-contabilidad-anuales.edit', {
                parent: 'consortium-contabilidad-anuales',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadAnuales'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales-detail.html',
                        controller: 'ConsortiumContabilidadAnualDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-contabilidad-anuales'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumContabilidadAnual', function($stateParams, ConsortiumContabilidadAnual) {
                        return ConsortiumContabilidadAnual.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-contabilidad-anuales',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
